import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AutoComplete, AutoCompleteCompleteEvent, AutoCompleteModule, AutoCompleteSelectEvent } from 'primeng/autocomplete';
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { MedicalService } from '../../../../services/medical.service';
import { FacilityLocation } from '../../../../models/facility';

@Component({
  selector: 'app-facility-location-search',
  standalone: true,
  imports: [AutoCompleteModule, FormsModule, DatePipe, CardModule, ButtonModule],
  templateUrl: './facility-location-search.component.html',
  styleUrl: './facility-location-search.component.scss'
})
export class FacilityLocationSearchComponent 
{
  @Input() facility?: FacilityLocation;
  @Input() placeholder: string = "Search";
  @Input() includeBilling: boolean = false;
  @Output() facilityChange: EventEmitter<FacilityLocation> = new EventEmitter<FacilityLocation>();
  @ViewChild('practiceSearchComponent') practiceSearchField?: AutoComplete;

  constructor
  (
    public _medicalService: MedicalService
  )
  {
  }

  groupedFacilitySuggestions:{label: string, items:FacilityLocation[]}[] = [];

  facilitySearch(event:AutoCompleteCompleteEvent )
  {
    //Update the suggestions to our query results
    this._medicalService.searchFacilities(event.query, this.includeBilling)
    .then
    (
      facilities => 
        {
          let groupedFacilities = facilities.reduce((memo:{[label: string]: FacilityLocation[]}, x:FacilityLocation) => 
          {
            if(!memo[x.displayText]) {memo[x.displayText] = []}
            memo[x.displayText].push(x);
            return memo;
          },{});

          this.groupedFacilitySuggestions = Object.keys(groupedFacilities).map
          (
            k => 
              {
                return {
                  label: k,
                  items: groupedFacilities[k]
                }
              }
          );
        }
    )
  }

  selectFacility(event: AutoCompleteSelectEvent)
  {
    this.facilityChange.emit(this.facility);
  }

  searchFor(input: string)
  {
    if(this.practiceSearchField)
    {
      this.practiceSearchField.writeValue(input);
      this.practiceSearchField.search(null,input,null);
    }
  }

}
